<template>
  <v-btn color="indigo" dark="" class="mr-5 mb-2 mt-2" @click="makeShootingBookPDF()">
    PDF
    <v-icon right>mdi-file-pdf-outline</v-icon>
  </v-btn>
</template>

<script>
import { jsPDF } from 'jspdf';
import { autoTable } from 'jspdf-autotable';

export default {
  name: 'shootingbookPDFExport',
  props: {
    pdf_data: {
      type: Array
    },
    name: {
      type: String
    },
    club_user: {
      type: String
    },
  },
  data: () => ({}),
  methods: {
    getFunctionName(id) {
      const map = { 1: "Schütze", 2: "Standaufsicht", 3: "Schießsportleiter" };
      return map[id] || "Unbekannt";
    },
    makeShootingBookPDF() {
      var source = this.pdf_data;
      let rows = [];
      let columnHeader = [];
      if (this.club_user === 'user') {
        columnHeader = ['Verein', 'Aktivität', 'Stand', 'Funktion', 'Waffe', 'Disziplin', 'Begin', 'Ende', 'bestätigt Verein'];
      } else if (this.club_user === 'club') {
        columnHeader = ['Name', 'Vorname', 'Stand', 'Funktion', 'Waffe', 'Disziplin', 'Begin', 'Ende', 'bestätigt Verein'];
      }
      let pdfName = 'Schiessbuch von \n' + this.name;
      let pdfDateiName = 'Schiessbuch von ' + this.name;
      let pdfImage = '/Bilder/book.png';
      source.forEach(element => {

        var temp = [];
        if (this.club_user === 'club'){
          temp = [
            element.name,
            element.vorname,
          ];
        } else if (this.club_user === 'user'){
          temp = [
            element.comp_vereinname,
            element.aktivitaet,
          ];
        }

        temp.push(
          element.KurzBez,
          element.shooting_function_name || element.Aufsicht || element.funktion_name || (isNaN(element.funktion) ? element.funktion : this.getFunctionName(element.shooting_function_id || element.funktion)),
          element.KurzT,
          element.LangBez,
          new Date(element.beginn.replace(" ", "T")).toLocaleString([], {dateStyle: 'short', timeStyle: 'short'}),
          element.club_id != null
            ? new Date(element.ende.replace(" ", "T")).toLocaleString([], {dateStyle: 'short', timeStyle: 'short'})
            : new Date(element.beginn.replace(" ", "T")).toLocaleString([], {dateStyle: 'short'}),
        );
        const status = element.bestaetigung_status;
        if (status === 2 && element.bestaetigt_vereinDatum) {
          temp.push(new Date(element.bestaetigt_vereinDatum.replace(" ", "T")).toLocaleString([], {
            dateStyle: 'short',
            timeStyle: 'short'
          }));
        } else if (status === 1) {
          temp.push('Eingereicht');
        } else if (status === 3) {
          temp.push('Abgelehnt');
        } else {
          temp.push('');
        }
        rows.push(temp);
      });

      var doc = new jsPDF({ orientation: 'landscape' });
      // Header
      doc.setFontSize(20);
      doc.setTextColor(40);
      doc.text(pdfName, 10, 22);
      doc.setFontSize(12);
      doc.text("Erstellt am " + new Date().toLocaleString([], {dateStyle: 'short', timeStyle: 'short'}) + " von schuetzenbuch.de", 10, 40);
      doc.addImage(pdfImage, "PNG", 265, 15, 20, 20);

      // Spaltenbreiten: A4 Querformat = 297mm, 10mm Rand beidseitig = 277mm nutzbar
      const colWidthsClub  = { 0: {cellWidth: 22}, 1: {cellWidth: 22}, 2: {cellWidth: 15}, 3: {cellWidth: 32}, 4: {cellWidth: 25}, 5: {cellWidth: 52}, 6: {cellWidth: 28}, 7: {cellWidth: 28}, 8: {cellWidth: 28} };
      const colWidthsUser  = { 0: {cellWidth: 38}, 1: {cellWidth: 20}, 2: {cellWidth: 15}, 3: {cellWidth: 32}, 4: {cellWidth: 25}, 5: {cellWidth: 52}, 6: {cellWidth: 28}, 7: {cellWidth: 28}, 8: {cellWidth: 28} };

      autoTable(doc, {
        head: [columnHeader],
        body: rows,
        startY: 50,
        margin: {horizontal: 10},
        styles: {overflow: 'linebreak', fontSize: 8},
        headStyles: {fillColor: [41, 128, 185], textColor: 255, fontStyle: 'bold', fontSize: 8},
        bodyStyles: {valign: 'top'},
        columnStyles: this.club_user === 'club' ? colWidthsClub : colWidthsUser,
        theme: 'striped',
        showHead: 'everyPage',
        didDrawPage: function (data) {
          var str = "Seite " + doc.internal.getNumberOfPages();
          doc.setFontSize(10);
          var pageSize = doc.internal.pageSize;
          var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
          doc.text(str, data.settings.margin.left, pageHeight - 10);
        }
      });
      doc.save(pdfDateiName + '.pdf');

    },
  },
}
</script>

<style scoped>

</style>